
<div class="container" style="padding-top: 10%;min-height:60vh">
    <h1 style="color:#e6e64c;text-align: center; font-size: 5em;font-weight: bold">404 NOT FOUND</h1>
    <p style="color:#323131;text-align: center;" >The page you are looking for does not exist.</p>
    <p style="color:#323131;text-align: center;">PLease feel free to <a [routerLink]="['/']" style="color:#48a5db;text-align: center;"> return home page</a></p>
</div>
